import useActivityModal from 'hooks/useActivityModal'
import useKanbanBoard from 'hooks/useKanbanBoard'
import useKanbanColumnStates from 'hooks/useKanbanColumnStates'
import useKanbanFilters from 'hooks/useKanbanFilters'
import useKanbanList from 'hooks/useKanbanList'

const useKanban = () => {
  const board = useKanbanBoard()
  const filters = useKanbanFilters()
  const list = useKanbanList()
  const columnStates = useKanbanColumnStates()
  const modal = useActivityModal()

  const refetchKanban = () => {
    columnStates.refetchColumnStates()
    list.refetchList()
  }

  return {
    refetchKanban,
    // board
    boardId: board.boardId,
    columns: board.columns,
    columnsLoading: board.columnsLoading,
    isBoardLoading: board.isBoardLoading,
    setColumns: board.setColumns,
    refreshColumns: board.refreshColumns,
    handleSaveColumns: board.handleSaveColumns,
    handleCloseColumnModal: board.handleCloseColumnModal,
    canDragColumn: board.canDragColumn,
    canFinalize: board.canFinalize,
    // column states
    columnStates: columnStates.columnStates,
    handleDeleteKanbanCard: columnStates.handleDeleteKanbanCard,
    handleDragEnd: columnStates.handleDragEnd,
    handleLoadMore: columnStates.handleLoadMore,
    addTaskToColumn: columnStates.addTaskToColumn,
    updateTaskInColumn: columnStates.updateTaskInColumn,
    // modal
    activityModalKey: modal.activityModalKey,
    activityModalOpen: modal.activityModalOpen,
    activityToEdit: modal.activityToEdit,
    handleCloseActivityModal: modal.handleCloseActivityModal,
    handleOpenCreate: modal.handleOpenCreate,
    handleOpenEdit: modal.handleOpenEdit,
    handleRemoveAttachment: modal.handleRemoveAttachment,
    handleSaveActivity: modal.handleSaveActivity,
    isSaving: modal.isSaving,
    manageColumnsOpen: board.manageColumnsOpen,
    // list
    listCurrentTab: list.listCurrentTab,
    listLoading: list.listLoading,
    listPage: list.listPage,
    listPerPage: list.listPerPage,
    listTasks: list.listTasks,
    listTotalCount: list.listTotalCount,
    hasUnlinked: list.hasUnlinked,
    hasSourceRemoved: list.hasSourceRemoved,
    handleDeleteCard: list.handleDeleteCard,
    handleListChangePage: list.handleListChangePage,
    handleListChangeRowsPerPage: list.handleListChangeRowsPerPage,
    handleListTabChange: list.handleListTabChange,
    // filters
    departments: modal.departments,
    filter: filters.filter,
    handleSearchValue: filters.handleSearchValue,
    isSearching: filters.isSearching,
    searchInput: filters.searchInput,
    users: filters.users,
    onlyMine: filters.onlyMine,
    setOnlyMine: filters.setOnlyMine,
    unlinkedOnly: filters.unlinkedOnly,
    setUnlinkedOnly: filters.setUnlinkedOnly,
    sourceRemovedOnly: filters.sourceRemovedOnly,
    setSourceRemovedOnly: filters.setSourceRemovedOnly,
    setViewMode: filters.setViewMode,
    viewMode: filters.viewMode,
  }
}

export default useKanban
